import React, { useEffect, useRef, useState } from "react";
import { Switch, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import LogoutIcon from "@mui/icons-material/Logout";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { callAPI } from "../../../../../axios";
import { getChainIdLS, getUserRoleCodeFromStorage, isValidRole, ScrollToTop } from "../../../../../utils/utils";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import { MdModeEditOutline } from "react-icons/md";
import BasicModal from "../../../../core/BaseComponents/Modal";
import deleteImg from '../../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import Custom_Paingation from "../../../../core/BaseComponents/Custom_Paingation";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const MasterAPKConfiguration = (props) => {
    let userRoleCode = getUserRoleCodeFromStorage();
    let { viewType="hotelApp", hotelDetails, createUpdateFlag=false } = props;
    const [loader, setLoader] = useState(false)
    const [uploadApkList, setUploadApkList] = useState([]);
    const [editHotel, setEditHotel] = useState(false);
    const [editHotelSid, setEditHotelSid] = useState("");
    const [editHotelUpdate, setEditHotelUpdate] = useState(false);
    const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
    const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState('');
    const [confirmDeleteHotel, setConfirmDeleteHotel] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [confirmAPICall, setConfirmAPICall] = useState(false);
    const [confirmAPICalling, setConfirmAPICalling] = useState(false);

    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [paginationError, setPaginationError] = useState("")
    const [inputPageValue, setInputPageValue] = useState(1)

    const recordsPerPage = 10;

    let validPermissionClassName = isValidRole("MASTER_APK_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        setValue,
    } = useForm({
        mode: 'onChange',
        defaultValues: { active: true }
    });

    const { chainId } = useSelector((state) => state.chainIdReducer);

    const handleSwitchChange = (checked) => {
        setValue("active", checked);
      };

    const onSubmit = (data) => {
        if (confirmAPICall && confirmAPICalling===false) {
            setConfirmAPICalling(true);
            return;
        }
       
        setConfirmAPICalling(false);
        let method = "POST";
        let url = `/package-activity`;
        if (editHotelUpdate) {
            method = "PUT"
            url = `/package-activity?sid=${editHotelSid?.sid}`;
        }
        setLoader(true);
        callAPI(url, method, data, { chainId: getChainIdLS() })
            .then(function (response) {
                setCreateHotelSuccessMsg(response?.message);
                reset({
                    packageName: '',
                    activityName: '',
                    sha1Digest:'',
                    active: true
                });
                uploadApkListApi();
                setEditHotelSid('');
                setEditHotel(false);
                setLoader(false);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    };

    const renderAPKActionIcon = (row) => {
        return (
            isValidRole("MASTER_APK_CONFIGURATION_MODIFY")?<>
                {!row?.active ? <><Tooltip title="Edit" arrow>
                    <span><MdModeEditOutline
                        className="edit-icon-enable"
                        onClick={() => { setEditHotel(true); setEditHotelSid(row) }}
                    /></span>
                </Tooltip>
                <Tooltip title="Delete" className="cursor-pointer" arrow>
                     <DeleteIcon
                        className="delete-icon-enable"
                        onClick={() => {
                            deleteHotelPopUpHandler(row);
                        }}
                    />
                </Tooltip></>:
                <>
                <Tooltip title="Disable to perform actions" arrow>
                  <span><MdModeEditOutline className="edit-icon-disable" /></span>
                </Tooltip>
                <Tooltip title="Disable to perform actions" arrow>
                  <DeleteIcon className="delete-icon-disable" />
                </Tooltip>
              </>}
                {/* <EnableDisableMasterAPKConfiguration editHotelSid={editHotelSid} row={row} setLoader={setLoader} hotelServiceListApi={uploadApkListApi} /> */}
            </>:<>
                <Tooltip title="Don't have permission to edit">
                    <span>
                        <MdModeEditOutline className="edit-icon-disable" arrow />
                    </span>
                </Tooltip>
                <Tooltip title="Don't have permission to delete">
                    <DeleteIcon className="delete-icon-disable" arrow />
                </Tooltip>
                <Tooltip title="Don't have permission to edit">
                    <span>
                    <Switch
                    name="active"
                    disabled={true}
                    // onChange={(event) => handleToggleChange(event, props?.row)}
                    inputProps={{ "aria-label": "controlled" }}
                    value={row.active}
                    checked={row.active}
                    className={`${row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                    />
                    </span>
            </Tooltip>
            </>
        );
    };
    const hotelColumns = [
        { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "packageName", headerName: "Package Name", flex: 1 },
        { field: "activityName", headerName: "Activity Name", flex: 1 },
        { field: "sha1Digest", headerName: "Sha1 Digest", flex: 1 },
        // {
        //     field: "actionCell",
        //     row: true,
        //     headerName: "Actions",
        //     flex: 0.5,
        //     renderCell: renderAPKActionIcon,
        //     sortDirection: false,
        //     disableSortIcon: true,
        // },
    ];

    const uploadApkListApi = () => {
        callAPI(`/package-activity-search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {}, { chainId: getChainIdLS() })
            .then((response) => {
                setUploadApkList(response?.packageResponse?.filter((data)=>data?.active))
                setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
                setPaginationError("")
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(() => {
        uploadApkListApi();
     }, [createUpdateFlag,chainId]);

    useEffect(() => {
        if (editHotelSid) {
            getHotelListSidHandler();
        }
        ScrollToTop();
    }, [editHotelSid]);

    const getHotelListSidHandler = () => {
        callAPI(`/package-activity-id?sid=${editHotelSid?.sid}`, "GET")
            .then(function (response) {
                const payload = {
                    packageName: response?.packageName,
                    activityName: response?.activityName,
                    sha1Digest:response?.sha1Digest,
                    active: response?.active
                };
                reset(payload);
                setEditHotelUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const cancelHotelHandler = () => {
        reset({
            packageName: '',
            activityName: '',
            sha1Digest:'',
            active: true,
        });
        setEditHotelUpdate(false);
        setEditHotelSid('');
        setEditHotel(false);
    }

    const resetLayoutHandler = () => {
        reset();
    }
    const popupCloseHandler = () => {
        setDeleteHotelPopUp(false);
    };
    const isHotelDeletedRef = useRef({
        isHotelDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteHotelPopUpHandler = (row) => {
        setDeleteHotelPopUp(true);
        const newModalRefData = {
            isHotelDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isHotelDeletedRef.current = newModalRefData;
    }

    const deleteHotelHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteHotel === "") {
            return
        }
        if (confirmDeleteHotel === `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}`) {
            setConfirmValidate(false)
            setLoader(true);
            const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
            callAPI(`/package-activity?sid=${row?.sid}`, "DELETE", {}, { chainId: getChainIdLS() })
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isHotelDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isHotelDeletedRef.current = newModalRefData;
                    uploadApkListApi();
                    setLoader(false);
                    // setEditHotelSid('');
                    cancelHotelHandler()
                })
                .catch((error) => {
                    console.warn(error);
                    setLoader(false);
                });
        }
        reset({
            packageName: '',
            activityName: '',
            sha1Digest:'',
            active: true,
        });
    }

    //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

    return (
        <div className="config-hotel">
        <div className="left-column">{(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp") &&
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
                <div className="row">
                    <div className="left-column-header">
                        <p>{editHotelUpdate ? 'Edit APK Details' : 'APK Details'}</p>
                    </div>
                    <div className="form-group-hotel col-6">
                        <div className={`floating-label`}>
                            <input
                                id="packageName"
                                maxLength={255}
                                placeholder=""
                                {...register("packageName", {
                                    required: "Please Enter Package Name",
                                })}
                            />
                            <label htmlFor="packageName">Package Name</label>
                        </div>
                        {errors.packageName && (
                            <small className="required">{errors.packageName.message}</small>
                        )}
                    </div>
                    <div className="form-group-hotel col-6">
                        <div className={`floating-label`}>
                            <input
                                id="activityName"
                                maxLength={255}
                                placeholder=""
                                {...register("activityName", {
                                    required: "Please Enter Activity Name",
                                })}
                            />
                            <label htmlFor="activityName">Activity Name</label>
                        </div>
                        {errors.activityName && (
                            <small className="required">{errors.activityName.message}</small>
                        )}
                    </div>
                    <div className="form-group-hotel col-6">
                        <div className={`floating-label`}>
                            <input
                                id="sha1Digest"
                                maxLength={255}
                                placeholder=""
                                onInput={(e) => {
                                    e.target.value = e.target.value.toLowerCase();
                                }}
                                {...register("sha1Digest", {
                                    required: "Please Enter SHA1 Fingerprint",
                                })}
                            />
                            <label htmlFor="sha1Digest">SHA1 Fingerprint</label>
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-1">
                            {errors.sha1Digest && (
                                <small className="required me-auto">{errors.sha1Digest.message}</small>
                            )}
                            <Tooltip
                                title="SHA must be 40 hexadecimal characters (0-9) and (a-f). Example: da39a3ee5e6b4b0d3255bfef95601890afd80709"
                                arrow
                            >
                                <span className="cursor-pointer d-inline-flex align-items-center" aria-label="SHA1 fingerprint help">
                                    <InfoOutlinedIcon sx={{ fontSize: 18, color: "#5e03c7" }} />
                                </span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className="col-12 form-group-hotel text-end">
                    <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>Cancel</button>
                    {editHotelUpdate && <>
                        <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                    </>}
                    <button type="submit" className="create-btn">{editHotelUpdate ? "Update" : "Upload"}</button>

                </div>
            </form>}
            {(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp") && <div className="hotel-list">
                {/* <div className="flex-items-between mb-3">
                    <p className="mb-0"><b>Master APK Configuration</b></p>
                        {(!editHotelUpdate && !editHotel )&& <button type="button" className={`create-btn ${validPermissionClassName} `} onClick={() => setEditHotel(true)}>Add New Config</button>}
                </div> */}
                <TableWrapper
                    data={uploadApkList}
                    columns={hotelColumns}
                    noPagination={true}
                    module="default"
                />
                <Custom_Paingation
                            selectedPage={selectedPage}
                            totalPageCount={totalPageCount}
                            paginationError={paginationError}
                            inputPageValue={inputPageValue}
                            setSelectedPage={setSelectedPage}
                            setPaginationError={setPaginationError}
                            setInputPageValue={setInputPageValue}
                            onPageChange={onPageChange}
                        />
            </div>}
            <BasicModal
                popupOpen={createHotelSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateHotelSuccessMsg(''); setEditHotelUpdate(false); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            <BasicModal
                popupOpen={confirmAPICalling}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">Targeted CDSN is already being used in another APK Version. This action will overwrite the existing linking.</p>}
                footer={
                    {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: ()=>{setConfirmAPICalling(false);}
                        },
                        secondaryButton: {
                            buttonName: "Upload",
                            action:  ()=>{setConfirmAPICall(false); handleSubmit(onSubmit)()},
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            {deleteHotelPopUp && <BasicModal
                popupOpen={deleteHotelPopUp}
                bodyMessage={<>
                    <img src={deleteImg} alt="approve" className="w-40px" />
                    <div className="delete-hotel">{isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        <div className="confirm-delete-hotel">
                            <p>Do you really want to Delete APK config" <b>{isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}</b> " ?</p>
                            <p className="warning"><IoMdWarning /> Warning</p>
                            <p>APK "{isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}" will be permanently deleted <br />
                                Deleting the specified APK config can't be undone.
                            </p>
                            {/* <p className="warning">Deleting the specific APK will impact CDSN mapping</p> */}
                            <p className="mt-3">To confirm deletion, type "Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}"</p>
                            <div className="form-group-hotel mt-3">
                                <div className="floating-label">
                                    <input
                                        id="deleteHotel"
                                        placeholder=""
                                        onChange={(e) => setConfirmDeleteHotel(e.target.value)}
                                    />
                                    <label htmlFor="address">Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}</label>
                                </div>
                                {(confirmDeleteHotel === "" && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}</small>
                                ) : (confirmDeleteHotel !== `${isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}` && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.packageName}</small>
                                ) : ""
                                }
                            </div>
                        </div> :
                        isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
                </>
                }
                footer={
                    isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Delete",
                                action: deleteHotelHandler
                            }
                        } : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler
                            }
                        }
                }
            />}
        </div>
        </div>
    )
}

export default MasterAPKConfiguration;